import React from 'react';

import { Checkbox } from '@components/common';

import { TExportAssetsRulesDTO } from '@interfaces/assets/dto/assetsDTO';

import styles from '../ExportRules.module.scss';

interface IAttributesParams {
	rules: TExportAssetsRulesDTO;
	isLoadingForm: boolean;
	onChange: (checked: boolean, name: string) => void;
	checkboxData: {
		headerText: string;
		nameStatus: string;
		nameDetails: string;
	};
}

const Attributes = ({
	rules,
	isLoadingForm,
	onChange,
	checkboxData,
}: IAttributesParams) => {
	const checkboxRules = rules as any;

	return (
		<div className={styles.attributes}>
			<p className={styles.attributesText}>
				{checkboxData.headerText}
			</p>
			<div className={styles.attributesCheckboxes}>
				<Checkbox
					checked={checkboxRules[checkboxData.nameStatus]}
					disabled={isLoadingForm}
					label='Status'
					name={checkboxData.nameStatus}
					onChange={onChange}
				/>
				<Checkbox
					checked={checkboxRules[checkboxData.nameDetails]}
					disabled={isLoadingForm}
					label='Details'
					name={checkboxData.nameDetails}
					onChange={onChange}
				/>
			</div>
		</div>
	);
};

export default Attributes;
